import React from 'react'
import styled from 'styled-components'
import { BrowserConsumer } from 'contexts/browser-context'
import { media } from 'tools/browser'
import PropTypes from 'prop-types'

const MainLogoWrapper = styled.a`
  height: 36px;
  max-width: 130px;

  display: flex;
  align-items: center;

  svg {
    max-height: 100%;
    height: 100%;
  }

  ${media.greaterThan.large`
        height: 45px;
        max-width: 150px;
    `}

  ${media.greaterThan.extraLarge`
        height: 60px;
        max-width: 200px;
    `}
`

function MainLogo(props) {
  const { wordmark } = props

  return (
    <BrowserConsumer>
      {(browserIs) => {
        return (
          <MainLogoWrapper isDesktop={browserIs.greaterThan.medium} href="/">
            {wordmark}
          </MainLogoWrapper>
        )
      }}
    </BrowserConsumer>
  )
}

MainLogo.propTypes = {
  wordmark: PropTypes.node.isRequired,
}

export default MainLogo



// WEBPACK FOOTER //
// ./src/atoms/MainLogo/MainLogo.js